<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">

      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">리워드 그레이스 신청</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>

      <div class="rew19_popup_cont">
        <p class="rew19_normalTxt">리워드 그레이스는 리워드 프로그램 기간 내 총 2회(비연속) 사용 가능하며, 그레이스 사용 월도 약정기간에 포함되어 리워드 프로그램이 유지됩니다.</p>

        <ul class="rew19_dotList topGepDesk">
          <li>리워드 그레이스는 스킨 케어 시스템 구매 후, 커스텀 프로덕트 세트를 3회 이상 구매/결제한 경우 가능합니다.</li>
          <li>리워드 그레이스는 연속해서 2회(2개월)을 사용하실 수 없습니다.</li>
        </ul>

        <ul class="rew19_underline_list type3">
          <li class="type2">
            <em class="longType">사용기록</em>
            <span class="substance">{{viewData.useLog}}</span>
          </li>
        </ul>

        <ul class="rew19_dotList topGepDesk">
          <li>결제일 하루 전까지만 신청 및 취소가 가능합니다.</li>
          <li>커스텀 프로덕트 3개월 결제 후 4개월 째(리워드 회차 5)부터 사용 가능합니다.</li>
          <li>리워드 그레이스는 연속 적용되지 않으므로 1회 사용 후 다음 회차부터 일반결제로 자동 전환되어 결제가 진행됩니다.</li>
        </ul>

        <p class="rew19_order_txt">{{viewData.applyMonth}}</p>
                  
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">신청</button>
      </div> 

    </div>
  </div>  
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";
import * as Const from "@/utils/const";

const DEFAULT_VIEWDATA = {
  useLog : "-",
  applyMonth : "리워드 그레이스 사용 시 0000년 00월 적용",
};

export default {
  name: 'AgelocRewardGraceDialog',
  extends: AroBase,
  components: {  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex : 2000,

      viewData : {...DEFAULT_VIEWDATA},
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;

  },  
  methods :{
    onClose(response, resData) {
      let _this = this;

      _this.$emit('close', response, response ? resData: null);      
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true, null);
    },

    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
        ...paramData,
      };
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/AgelocRewardGraceDialog.vue